import { render, staticRenderFns } from "./exitIcon.vue?vue&type=template&id=28b510dc&scoped=true&"
import script from "./exitIcon.vue?vue&type=script&lang=js&"
export * from "./exitIcon.vue?vue&type=script&lang=js&"
import style0 from "./exitIcon.vue?vue&type=style&index=0&id=28b510dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b510dc",
  null
  
)

export default component.exports